import { AIChatPlugin } from '@alpod-ai-writer/plate-plugins/ai/react';
import { useEditorPlugin } from '@udecode/plate/react';
import { SparklesIcon } from 'lucide-react';
import type React from 'react';
import { useCallback } from 'react';

import { ToolbarButton } from './toolbarButton.component';

export const AiToolbarButtonAccent: React.FC = () => {
    const { api } = useEditorPlugin(AIChatPlugin);

    const handleClick = useCallback(() => {
        api.aiChat.show();
    }, [ api ]);

    return (
        <ToolbarButton
            rounded
            style='feature-accent'
            size='md'
            onMouseDown={(e) => { e.preventDefault(); handleClick(); }}
        ><SparklesIcon size={18} /> <span className='hidden xl:block'>Použít AI</span> <span className='lg:hidden'>AI</span></ToolbarButton>
    );
};
